import React, { useEffect } from 'react'

const ModalContent = ({
  content,
  title = 'Modal title',
  idModal = 'defaultModalId',
  size = 'normal',
  onClose = () => {},
  classModalDialogOptions = 'modal-dialog-scrollable modal-dialog-centered',
}) => {
  let sizeModal = null
  switch (size) {
    case 'small':
      sizeModal = 'modal-sm'
      break

    case 'medium':
      sizeModal = 'modal-md'
      break

    case 'large':
      sizeModal = 'modal-lg'
      break

    case 'extra':
      sizeModal = 'modal-xl'
      break

    case 'full':
      sizeModal = 'modal-fullscreen'
      break

    default:
      sizeModal = ''
      break
  }

  //detect click outside the modal
  useEffect(() => {
    if (window?.jQuery) {
      window?.jQuery('#' + idModal).on('hide.bs.modal', function () {
        onClose()
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className="modal fade"
      id={idModal}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={`${idModal}Title`}
      aria-hidden="true"
    >
      <div
        className={`modal-dialog ${classModalDialogOptions} ${sizeModal}`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {title}
            </h5>
            <button
              type="button"
              className="modal-close-button align-items-end"
              data-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            >
              <span aria-hidden="true" onClick={onClose}>
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">{content}</div>
        </div>
      </div>
    </div>
  )
}

export default ModalContent
